var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPendingReviewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(-35 -35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    width: 84,
    height: 84,
    rx: 10,
    transform: "translate(35 35)",
    fill: "#ffd950",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(57.206 50.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M227.023,284.666q-2.139,2.2-4.34,4.338a2.276,2.276,0,0,1-3.462-.029c-.684-.649-1.345-1.321-1.994-2a2.332,2.332,0,0,1-.187-3.379,2.388,2.388,0,0,1,3.4.135c.153.133.3.273.6.553.959-.991,1.847-1.95,2.781-2.867a2.233,2.233,0,0,1,3.364-.138A2.324,2.324,0,0,1,227.023,284.666Z",
    transform: "translate(-209.236 -264.566)",
    fill: "#ffd950"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M227.023,316.666q-2.139,2.2-4.34,4.338a2.276,2.276,0,0,1-3.462-.029c-.684-.649-1.345-1.321-1.994-2a2.332,2.332,0,0,1-.187-3.379,2.388,2.388,0,0,1,3.4.135c.153.133.3.273.6.553.959-.991,1.847-1.95,2.781-2.867a2.233,2.233,0,0,1,3.364-.138A2.324,2.324,0,0,1,227.023,316.666Z",
    transform: "translate(-209.236 -283.866)",
    fill: "#ffd950"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M238.736,249.759a13.654,13.654,0,0,0-.041-1.417,4.331,4.331,0,0,0-2.818-3.706,4.452,4.452,0,0,0-1.454-.269c-.11,0-.22,0-.334,0s-.212,0-.318,0c-1.409-.016-2.822,0-4.235,0-.265,0-.529-.037-.847-.065a3.605,3.605,0,0,0-2.395-4.06H210.589l-.061.024a3.606,3.606,0,0,0-2.329,4.031c-.35.024-.639.069-.928.069-1.376.008-2.757-.012-4.133,0-.106,0-.212,0-.318,0-.151,0-.3,0-.452,0a4.44,4.44,0,0,0-2.354.713l-.11.073a3.7,3.7,0,0,0-1.376,1.613c-.02.041-.041.086-.061.126s-.037.094-.057.143a4.565,4.565,0,0,0-.33,1.307l-.012.159c-.037.415-.033.835-.033,1.258q-.006,13.286,0,26.579v7.416a9.343,9.343,0,0,0,.277,2.614c.419,1.385,1.368,2.122,3.335,2.948h33.5c1.873-.79,2.822-1.5,3.262-2.777a8.617,8.617,0,0,0,.334-2.785V275.3Q238.74,262.523,238.736,249.759Zm-26.323-5.384h12v3.974h-12Zm22.308,39.814c-.008.819-.269,1.051-1.1,1.043-4.333-.024-8.666-.02-13-.02h-4.378c-4.357,0-8.711,0-13.068.02-.859.008-1.112-.236-1.108-1.108v-.012q.018-7.073.02-14.151.006-10.256-.016-20.512a2.558,2.558,0,0,1,.029-.415v-.008a.678.678,0,0,1,.627-.656h1.344a.1.1,0,0,1,.049,0c1.038.008,2.085,0,3.156,0h.9c.012.1.02.2.024.285a8.481,8.481,0,0,0,.012.924,3.1,3.1,0,0,0,1.535,2.48c.065.037.13.073.2.1a2.023,2.023,0,0,0,.2.086c.09.037.179.065.273.094a2.284,2.284,0,0,0,.289.065c.1.02.2.033.3.045s.2.012.309.012q7.11.024,14.229,0h.033a3.063,3.063,0,0,0,3.111-2.883c.033-.354,0-.717,0-1.209h.835c1.071,0,2.118.012,3.16,0a.115.115,0,0,1,.053,0h1.323c.533.081.66.432.66,1.079q-.012,7.953-.016,15.9v4.532q0,1.539,0,3.075,0,2.523,0,5.037.006,3.066.012,6.129Z",
    transform: "translate(-198.03 -240.23)",
    fill: "#ffd950"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M264.191,302.785a2.21,2.21,0,0,1-2.41,2.341c-1.17.009-2.336.014-3.507.014-2.561.009-5.123,0-7.679-.014a2.253,2.253,0,0,1-2.456-2.309,2.142,2.142,0,0,1,1.735-2.111,3.334,3.334,0,0,1,.7-.083c1.887-.023,3.773-.009,5.655-.009,1.845,0,3.686-.014,5.531,0C263.287,300.642,264.159,301.436,264.191,302.785Z",
    transform: "translate(-230.315 -276.301)",
    fill: "#ffd950"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M261.9,323.32a2.314,2.314,0,0,1-2.373,2.249q-.145.014-.289.014c-1.432.014-2.869,0-4.3,0s-2.869.018-4.3,0a2.234,2.234,0,0,1-2.506-2.254,2.284,2.284,0,0,1,2.566-2.332q3.808-.028,7.62,0c.326,0,.652,0,.978,0A2.353,2.353,0,0,1,261.9,323.32Z",
    transform: "translate(-228.845 -288.476)",
    fill: "#ffd950"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M257.278,282.624a2.174,2.174,0,0,1-2.162,2.336c-.307.023-.611.032-.918.032-.2,0-.4,0-.606-.009-.046,0-.092,0-.133,0-.161,0-.312,0-.473,0-.051,0-.106,0-.161,0h-.165c-.119,0-.239,0-.358,0-.179,0-.358,0-.537.009-.33.009-.656.009-.987,0-.147,0-.3-.014-.45-.023a2.254,2.254,0,0,1-2.19-2.336,2.223,2.223,0,0,1,2.185-2.217c1.593-.073,3.195-.069,4.788,0A2.192,2.192,0,0,1,257.278,282.624Z",
    transform: "translate(-228.379 -264.205)",
    fill: "#ffd950"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingReviewIcon);
export default __webpack_public_path__ + "static/media/PendingReviewIcon.b18a84c54fc7fdd42fd045fdb4d7dcc4.svg";
export { ForwardRef as ReactComponent };